import gsap from 'gsap'

export default function initExpandTopThree() {
	const rows = document.querySelectorAll('.expand-top-three .top-three-row')
	if (!rows.length || window.innerWidth < 1280) return

	const CUT_SIZE = 40
	const GAP_FIX = 2

	const updateClip = el => {
		const p = parseFloat(gsap.getProperty(el, '--clip-progress')) || 0
		const h = el.offsetHeight
		const c = CUT_SIZE * p

		el.style.clipPath = `polygon(0 0, calc(100% + ${GAP_FIX}px) 0, calc(100% + ${GAP_FIX}px) ${h - c}px, calc(100% - ${c}px) ${h}px, 0 ${h}px)`
	}

	const getAvailableRowWidth = (row, count) => {
		const styles = window.getComputedStyle(row)
		const gap = parseFloat(styles.columnGap || styles.gap) || 0

		return row.clientWidth - gap * (count - 1)
	}

	rows.forEach(row => {
		const teases = [...row.querySelectorAll('.tease')]
		if (!teases.length) return

		const initialHeight = teases[0].offsetHeight
		row.style.height = initialHeight + 'px'

		teases.forEach(tease => {
			tease.style.height = initialHeight + 'px'

			const content = tease.querySelector('[data-tease-content]')
			if (!content) return

			content.style.maxWidth = tease.offsetWidth + GAP_FIX + 'px'

			gsap.set(content, { '--clip-progress': 0 })
			updateClip(content)
		})

		teases.forEach(tease => {
			const content = tease.querySelector('[data-tease-content]')

			tease.addEventListener('mouseenter', () => {
				const siblings = teases.filter(t => t !== tease)
				const availableWidth = getAvailableRowWidth(row, teases.length)
				const collapsedWidth = availableWidth * 0.15

				gsap.to(tease, {
					flex: '1 1 70%',
					duration: 0.75,
					ease: 'power3.out',
					overwrite: true,
				})

				gsap.to(siblings, {
					flex: '1 1 15%',
					duration: 0.75,
					ease: 'power3.out',
					overwrite: true,
				})

				if (content) {
					gsap.to(content, {
						maxWidth: 600,
						'--clip-progress': 1,
						duration: 0.75,
						ease: 'power3.out',
						overwrite: true,
						onUpdate() {
							updateClip(content)
						},
					})
				}

				siblings.forEach(sib => {
					const sc = sib.querySelector('[data-tease-content]')
					if (!sc) return

					gsap.to(sc, {
						maxWidth: collapsedWidth + GAP_FIX,
						'--clip-progress': 0,
						duration: 0.75,
						ease: 'power3.out',
						overwrite: true,
						onUpdate() {
							updateClip(sc)
						},
					})
				})
			})
		})

		row.addEventListener('mouseleave', () => {
			const availableWidth = getAvailableRowWidth(row, teases.length)
			const equalWidth = availableWidth / teases.length

			gsap.to(teases, {
				flex: '1 1 33.333%',
				duration: 1,
				ease: 'power3.out',
				overwrite: true,
			})

			teases.forEach(tease => {
				const content = tease.querySelector('[data-tease-content]')
				if (!content) return

				gsap.to(content, {
					maxWidth: equalWidth + GAP_FIX,
					'--clip-progress': 0,
					duration: 1,
					ease: 'power3.out',
					overwrite: true,
					onUpdate() {
						updateClip(content)
					},
				})
			})
		})
	})
}